<div class="kyc-tabs" >
  <div class="secondary-tab" *ngIf="loanDetails?.loanApplicantDetails?.length>1 && !isMoratorium">
    <div class="tab-item" [class.active]="currentApplicant.mainApplicant" (click)="switchTab(true)">Applicant</div>
    <div class="tab-item" [class.active]="!currentApplicant.mainApplicant" (click)="switchTab(false)">Co-Applicant</div>
  </div>
  </div>
<section class="kyc-detail-wrap">
  <div class="left">
    <div class="kyc-title">
      <img src="assets/images/icons/aadhaar.svg" alt="Aadhaar Icon"/>
      <div class="title-content">
        <div class="title-name">Aadhaar Details</div>
        <div class="title-info">OTP will be sent to the linked number</div>
      </div>
    </div>
    <app-aadhar-details [switchTabs]="switchTabEvent"></app-aadhar-details>
  </div>
  <div class="right">
    <div class="kyc-title">
      <img src="assets/images/icons/camera.svg" alt="Camera Icon"/>
      <div class="title-content">
        <div class="title-name">Take Applicant's Selfie</div>
        <div class="title-info">Make sure the face is clear and visible</div>
      </div>
    </div>
    <app-selfie [switchTabs]="switchTabEvent"></app-selfie>
  </div>
</section>
